/* file description */
import React, { FC, useEffect, useState, useRef } from 'react';
import { useSetVal } from './effect';
import { RecordTreeSelectProps } from './type';
import { COLUMN_FROM } from '../../effects/consts';
import { TreeSelect, Tree, Spin } from 'antd';
import { Button, Popup, Space, Cascader, Toast } from 'antd-mobile';
import _ from 'lodash';
import { MobileInput } from '../MobileInput';
import memo from '../memo';
import { getTreeData } from '@/common/asset-apis/assetModel';
import { Api } from '@cui/req';
import { mockCityList } from './consts';
import styles from './index.module.less';

const mobielBoxStyles = { width: '100%', border: '1px solid #D8D8D8', padding: '11px', height: '32px', boxSizing: 'border-box' };
const generateTree = (
  list,
  rootId,
  { idName = 'value', parentIdName = 'pId', childrenName = 'children' } = {},
) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks

  if (!Array.isArray(list)) {
    new Error('only Array');
    return list;
  }
  const objMap: any = {};
  const result = [];
  for (const item of list) {
    item.label = item.title;
    item.mobileValue = [item.value];

    const id = item[idName];
    const parentId = item[parentIdName];
    objMap[id] = !objMap[id] ? item : { ...item, ...objMap[id] };

    const treeItem = objMap[id];
    if (parentId === rootId) {
      result.push(treeItem);
    } else {
      // const fa = list.find((item) => item.value === parentId);
      // treeItem.mobileValue = [...fa.mobileValue, ...treeItem.mobileValue];
      if (!objMap[parentId]) {
        objMap[parentId] = {};
      }

      if (!objMap[parentId][childrenName]) {
        objMap[parentId][childrenName] = [];
      }
      objMap[parentId][childrenName].push(treeItem);
    }
  }
  return result;
};


export const AreaSelect: FC<RecordTreeSelectProps> = ({
  field,
  value,
  onChange,
  form,
  config,
  columnFrom,
  isMobile,
  allowClear,
  disabled,
  moduleInfo,
}) => {
  const { dispatchEvent, destroyEvent } = config.metaStore || {};
  const [filterData, setTreeData] = useState<any[]>([]);
  const isMounted = useRef(true);
  const treeRef = useRef<any>();
  const { selectTree } = useSetVal({ onChange, form, field, config });
  const [parentValue, setparentValue] = useState('');
  const [searchList, setSearchList] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const type = field?.bizConfig?.type || [];
  const parentField = field?.bizConfig?.parentField || '';

  useEffect(() => {
    if (parentField) {
      let pvalue: string | undefined;
      if (columnFrom === COLUMN_FROM.TABLE) {
        if (config.formValue?.[config.rowIndex]) {
          pvalue = config.formValue?.[config.rowIndex]?.[parentField];
        }
      } else {
        pvalue = config.formValue?.[parentField];
      }
      setparentValue(pvalue);

      const events = [{
        code: field.name,
        name: field.label,
        touchConfig: 'change',
        actionType: 'callback',
        moduleName: moduleInfo.handle,
        fieldName: parentField,
        rowIndex: config.rowIndex,
        fun: (value: any) => {
          onChange?.(null);
          setparentValue(value);
        },
      }];
      const ids = dispatchEvent?.(events);
      return () => {
        destroyEvent?.(ids);
      };
    }
  }, []);

  const getSimpleData = (data: any[]) => {
    return data?.map((item: any) => {
      return {
        id: item.number,
        pId: item.superior_number,
        value: item.number,
        title: item.name,
        type: item.administrative_division_type,
        isLeaf: type[type.length - 1] === item.administrative_division_type,
      };
    });
  };

  useEffect(() => {
    if (type.join() === '04' && ['110000', '120000', '310000', '500000', '810000', '820000'].includes(parentValue)) {
      // 省市区分三个下拉框时，直辖市等没有市级，处理
      const cityData = mockCityList.find((item: any) => item.id === parentValue);
      setTreeData([cityData]);
    } else {
      const firstType = type?.length > 0 ? type[0] : '01';
      const params = {
        condition: 'administrative_division_type=${type}',
        idKey: 'number',
        parameters: {
          type: firstType,
        },
        pidKey: 'superior_number',
        namespaceID: 'base',
        moduleID: 'bd_administrative_division',
      };
      if (parentField) {
        params.condition = 'administrative_division_type=${type} and superior_number=${parentValue}';
        params.parameters.parentValue = parentValue;
      }
      getTreeData(Api, params).then((res) => {
        let simpleData = getSimpleData(res?.treeDataList);
        simpleData = simpleData.filter((item: any) => type.includes(item.type));
        setTreeData(simpleData);
        if (isMobile) {
          const treeList = arrToTree(simpleData);
          setTreeData(treeList);
        }
      });
    }
  }, [parentValue]);

  useEffect(() => {
    if (type?.length > 1 && value && filterData?.length > 0) {
      if (filterData.every((item: any) => item.value !== value)) {
        const params = {
          condition: 'number=${value}',
          idKey: 'number',
          parameters: {
            value,
          },
          pidKey: 'superior_number',
          namespaceID: 'base',
          moduleID: 'bd_administrative_division',
        };
        getTreeData(Api, params).then((res) => {
          let simpleData = getSimpleData(res?.treeDataList);
          simpleData = simpleData.filter((item: any) => type.includes(item.type));
          if (simpleData?.length > 0) {
            const filterMap = new Map();
            setTreeData([...filterData, ...simpleData].filter((item: any) => !filterMap.has(item.value) && filterMap.set(item.value, 1)));
          }
        });
      } else {
        // 选择后拼接所有上级显示
        const node = filterData.find((item: any) => item.value === value);
        if (!node.fullTitle) {
          const concatTitle: any[] = [node.title];
          getTitle(node, concatTitle, _.cloneDeep(filterData));
          node.fullTitle = concatTitle.join('/');
          const filterMap = new Map();
          setTreeData([...filterData, ...[node]].filter((item: any) => !filterMap.has(item.value) && filterMap.set(item.value, 1)));
        }
      }
    }
  }, [value, filterData]);

  const onLoadData = (node: any) => {
    return new Promise(resolve => {
      const superiorNumber = node.id;
      const params = {
        condition: 'superior_number=${superiorNumber}',
        idKey: 'number',
        parameters: {
          superiorNumber,
        },
        pidKey: 'superior_number',
        namespaceID: 'base',
        moduleID: 'bd_administrative_division',
      };
      // const loadType = '0' + (Number(node.type) + 1);
      getTreeData(Api, params).then((res) => {
        let simpleData = getSimpleData(res?.treeDataList);
        simpleData = simpleData.filter((item: any) => type.includes(item.type));
        // simpleData = simpleData.filter((item: any) => item.type === loadType && type.includes(item.type));
        const filterMap = new Map();
        setTreeData([...filterData, ...simpleData].filter((item: any) => !filterMap.has(item.value) && filterMap.set(item.value, 1)));
        resolve(undefined);
      });
    });
  };

  const searchData = (val: string, treeData: any[]) => {
    const params = {
      condition: "administrative_division_type in(${type}) and name ILIKE '%${val}%'",
      idKey: 'number',
      parameters: {
        type,
        // 传' 后端报错
        val: val.replace("'", ''),
      },
      pidKey: 'superior_number',
      namespaceID: 'base',
      moduleID: 'bd_administrative_division',
    };
    getTreeData(Api, params).then((res) => {
      let simpleData = getSimpleData(res?.treeDataList);
      simpleData = simpleData.filter((item: any) => type.includes(item.type));
      setSearchList(simpleData);
      const filterMap = new Map();
      setTreeData([...treeData, ...simpleData].filter((item: any) => !filterMap.has(item.value) && filterMap.set(item.value, 1)));
      setLoading(false);
    });
  };

  const setServicesValueDebounced = useRef(_.debounce(searchData, 500));

  const onSearch = (searchText: string) => {
    setSearchValue(searchText);
    if (!(searchText?.length > 0)) {
      return;
    }
    setLoading(true);
    setServicesValueDebounced.current(searchText, filterData);
  };

  const filterTreeNode = () => {
    return false;
  };

  const getTitle = (data: any, concatTitle: any[], sourceList: any[], key?: string) => {
    const pNode = sourceList.find((item: any) => item.id === data.pId);
    if (pNode) {
      concatTitle.unshift(pNode[key || 'title']);
      getTitle(pNode, concatTitle, sourceList, key);
    }
  };

  const flatMap = (array: any[], fn: Function) => {
    let result: any[] = [];
    for (let i = 0; i < array.length; i++) {
      const mapping = fn(array[i]);
      result = result.concat(mapping);
    }
    return result;
  };

  // const treeLoadData = (node: any) => {
  //   return new Promise((resolve: any) => {
  //     const lastExpandType = type.sort()[type.length - 2];
  //     if (node.type === lastExpandType) {
  //       const superiorNumber = node.id;
  //       const params = {
  //         condition: 'superior_number=${superiorNumber}',
  //         idKey: 'number',
  //         parameters: {
  //           superiorNumber,
  //         },
  //         pidKey: 'superior_number',
  //         namespaceID: 'base',
  //         moduleID: 'bd_administrative_division',
  //       };
  //       getTreeData(Api, params).then((res) => {
  //         let simpleData = getSimpleData(res?.treeDataList);
  //         simpleData = simpleData.filter((item: any) => type.includes(item.type));
  //         const filterMap = new Map();
  //         setSearchList([...searchList, ...simpleData].filter((item: any) => !filterMap.has(item.value) && filterMap.set(item.value, 1)));
  //         resolve();
  //       });
  //     } else {
  //       resolve();
  //     }
  //   });
  // };

  const searchContent = () => {
    const matchList = _.cloneDeep(searchList).filter((item: any) => item.title.includes(searchValue));
    matchList.forEach((item) => {
      const concatTitle: any[] = [item.title];
      getTitle(item, concatTitle, _.cloneDeep(searchList));
      item.isLeaf = true;
      item.title = concatTitle.join('/');
    });
    if (matchList.length > 0) {
      return (
        <div className={styles['area-search-content']}>
          <Tree
            fieldNames={{
              key: 'id',
            }}
            titleRender={(node) => {
              let result = node.title;
              result = flatMap(result.split(searchValue), (part: string) => {
                return [part, <span style={{ color: '#0064CE' }}>{searchValue}</span>];
              });
              result.pop();
              return (
                <>
                  {result}
                </>
              );
            }}
            onSelect={(key, node) => {
              treeRef.current.blur();
              selectTree(key[0]);
              onSelect(key[0], node.node);
            }}
            // loadData={treeLoadData}
            treeData={matchList}
          />
        </div>
      );
    } else {
      const ele = loading ? <div style={{ color: 'rgba(0,0,0,0.25)', marginLeft: '10px' }}><Spin style={{ marginRight: '5px' }} size="small" />搜索中</div> : <div style={{ color: 'rgba(0,0,0,0.25)', marginLeft: '10px' }}>结果无匹配</div>;
      return ele;
    }
  };

  const arrToTree = (arr: any[]) => {
    const data = _.cloneDeep(arr);
    const res: any[] = [];
    const map: Record<any, any> = {};
    data.forEach((item) => {
      item.label = item.title;
      map[item.id] = item;
    });
    data.forEach((item) => {
      const parent = map[item.pId];
      if (parent) {
        (parent.children || (parent.children = [])).push(item);
      } else {
        res.push(item);
      }
    });
    return res;
  };

  const [cascaderVis, seCascaderVis] = useState(false);

  const flatTree = (data: any[], result: any[]) => {
    data.forEach((item: any) => {
      result.push(item);
      if (item?.children?.length) {
        flatTree(item.children, result);
      }
    });
  };

  const getPathById = (key: string) => {
    if (value) {
      const result: any[] = [];
      flatTree(filterData, result);
      const data = result.find((item: any) => item.value === value);
      if (!data) {
        return value;
      }
      const concatTitle: any[] = key === 'value' ? [value] : [data.title];
      getTitle(data, concatTitle, _.cloneDeep(result), key);
      return key === 'value' ? concatTitle : concatTitle.join('/');
    } else {
      return '';
    }
  };

  const expandMobileTree = (val: any[]) => {
    const superiorNumber = val[val.length - 1];
    const params = {
      condition: 'superior_number=${superiorNumber}',
      idKey: 'number',
      parameters: {
        superiorNumber,
      },
      pidKey: 'superior_number',
      namespaceID: 'base',
      moduleID: 'bd_administrative_division',
    };
    getTreeData(Api, params).then((res) => {
      let simpleData = getSimpleData(res?.treeDataList);
      simpleData = simpleData.filter((item: any) => type.includes(item.type));
      const result: any[] = [];
      flatTree(filterData, result);
      const filterMap = new Map();
      const resultData = [...result, ...simpleData].filter((item: any) => !filterMap.has(item.value) && filterMap.set(item.value, 1));
      setTreeData(arrToTree(resultData));
    });
  };


  if (isMobile) {
    return (
      <>
        <MobileInput
          value={getPathById('title') || ''}
          onClick={() => seCascaderVis(true)}
          disabled={disabled}
        />
        <Cascader
          options={filterData || []}
          visible={cascaderVis}
          onClose={() => seCascaderVis(false)}
          value={getPathById('value') || []}
          onSelect={expandMobileTree}
          onConfirm={(v) => {
            selectTree(_.last(v) || '');
          }}
        />
      </>
    );
  }
  // 省市区联动赋值
  const onSelect = (val: string | number, node: any) => {
    if (config.from === 'search') {
      return;
    }
    const { areaProvince, areaCity, areaCounty } = field?.bizConfig || {};
    form.setFieldValue(areaProvince, '');
    form.setFieldValue(areaCity, '');
    form.setFieldValue(areaCounty, '');
    switch (node.type) {
      case '03':
        form.setFieldValue(areaProvince, node.value);
        break;
      case '04':
        form.setFieldValue(areaProvince, node.pId);
        form.setFieldValue(areaCity, node.value);
        break;
      case '05':
        // 直辖市没有市级
        if (['110000', '120000', '310000', '500000', '810000', '820000'].includes(node.pId)) {
          form.setFieldValue(areaProvince, node.pId);
        } else {
          form.setFieldValue(areaProvince, filterData?.find((item: any) => item.value === node.pId)?.pId);
          form.setFieldValue(areaCity, node.pId);
        }
        form.setFieldValue(areaCounty, node.value);
        break;
    }
  };

  return (
    <>
      <TreeSelect
        // treeDataSimpleMode={{
        //   id: 'value',
        //   pId: 'pId',
        // }}
        ref={treeRef}
        treeDataSimpleMode
        style={{ width: '100%', minWidth: '100px' }}
        allowClear={allowClear !== false}
        showSearch
        treeNodeFilterProp="title"
        dropdownMatchSelectWidth={false}
        treeNodeLabelProp={type.length > 1 ? 'fullTitle' : undefined}
        value={value}
        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
        treeData={filterData}
        filterTreeNode={type.length > 1 ? filterTreeNode : undefined}
        notFoundContent={type.length > 1 ? (searchValue ? searchContent() : undefined) : undefined}
        loadData={onLoadData}
        onSearch={onSearch}
        onChange={selectTree}
        onSelect={onSelect}
        disabled={disabled}
      />
    </>
  );
};
export default memo(AreaSelect);
